<template>
    <div>
        <div class="category-slide"
            :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]"
            v-if="isHaveItem">
            <div class="category-headline">
                <div class="category-name">{{localeCode == 1033 ? category.name_en : category.name_th}}</div>
                <div class="category-see-all"
                    @click="clickSeeAll()">
                    <div>{{lbl.home.see_all}}</div>
                    <img class="ic-see-all" src="../../../../assets/icon/ic_caret_right.svg" />
                </div>
            </div>
            <div>
                <Carousel class="category-carousel"
                    :margin="carouselConfig.margin"
                    :responsive="carouselConfig.responsive"
                    :lazyLoad="true"
                    :dots="false"
                    :autoWidth="true"
                    :rewind="false"
                    :navText="['','']"
                    v-if="isHaveItem">
                    <RewardCategoryItem
                        class="category-item"
                        :category="category"
                        :isAmbassadorCategory="isAmbassadorCategory"
                        :isMainCategory="true"
                        @clickCategory="clickCategory($event)" />
                    <RewardCategoryItem
                        class="category-item"
                        v-for="(subcategory, index) in category.subcats"
                        :key="index"
                        :category="subcategory"
                        :isAmbassadorCategory="isAmbassadorCategory"
                        @clickCategory="clickCategory($event)" />
                </Carousel>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
// 3rd party
import Carousel from 'vue-owl-carousel'; // https://github.com/s950329/vue-owl-carousel
// helper
import Locale from '@/helper/locale/locale.js';
import { TrackingService } from "@/helper/TrackingHelper.js";
import LocaleMixin from '@/mixin/LocaleMixin.js';
// component
import RewardCategoryItem from '@/module/Reward/component/Category/RewardCategoryItem.vue';

export default {
    name: 'HomeCategorySlide',
    mixins: [LocaleMixin],
    components: {
        Carousel,
        RewardCategoryItem
    },
    props: {
        category: { type: Object, required: true },
        isAmbassadorCategory: { type: Boolean, default: false}
    },
    computed: {
        theme: function () {
            return this.$store.state.theme;
        },
        isAmbassador: function () {
            return this.$store.state.isAmbassador;
        },
        isHaveItem: function () {
            return (this.category.campaign_count)
        }
    },
    data: function () {
        return {
            lbl: Locale.getLbl(),

            carouselConfig: {
                margin: 10,
                responsive: {
                    0: { items: 1 },
                },
            },

            trackingService: new TrackingService(this)
        }
    },
    methods: {
        clickCategory: function (categoryInfo) {
            this.trackingService.event('homepage_list', 'click_subcategory_list', categoryInfo.category.id + '|' + categoryInfo.category.name, null);

            if (categoryInfo.isMainCategory) {
                this.$router.push(`/reward/${this.category.id}`);
            } else {
                this.$router.push(`/reward/${this.category.id}/sub/${categoryInfo.category.id}`);
            }
        },
        clickSeeAll: function () {
            this.$router.push(`/reward/${this.category.id}`);
        },
        getCategoryImgUrl: function (category) {
            if (category.mode == 'all')
                return `${Vue.bzbsConfig.bzbsBlobUrl}${Vue.bzbsConfig.categoryConfig.menuCategoryImgUrl}${this.theme}/all`
            else
                return `${Vue.bzbsConfig.bzbsBlobUrl}${Vue.bzbsConfig.categoryConfig.menuCategoryImgUrl}${this.theme}/${category.id}`
        },
    }
}
</script>
<style lang="scss" scoped>
@import "@/style/base/base.scss";
.category-slide {

    .category-headline {
        display: flex;
        justify-content: space-between;
        padding: {
            left: $base-padding-x;
            right: $base-padding-x;
        };
        margin-bottom: 5px;

        .category-name {
            // font-family: $heading;
            font-size: 20px;
        }

        .category-see-all {
            position: relative;
            display: flex;
            margin: {
                top: auto;
                bottom: auto;
            }
            // font-family: $heading;
            font-size: 14px;

            .ic-see-all {
                display: block;
                width: 10px;
                height: 10px;
                margin: {
                    top: auto;
                    bottom: auto;
                    left: 3px;
                }
            }
        }
    }

    &.mass {
        .category-headline {
            .category-name {
                color: $mass_theme_color;
            }
            .category-see-all {
                color: $prestige_font_color_2;
            }
        }
    }

    &.prestige {
        .category-headline {
            .category-name {
                color: $prestige_theme_color;
            }
            .category-see-all {
                color: $prestige_font_color_2;
            }
        }
    }
}

.category-item {
    height: 100%;
}
</style>
<style lang="scss">
@import "@/style/base/base.scss";
@import '@/style/base/query.scss';
.category-carousel {
    .owl-carousel {
        .owl-stage-outer .owl-stage {
            display: flex;
            padding-left: 15px !important;
            padding-bottom: 15px;

            .owl-item {
                flex: 0 0 auto;
                width: calc(100vw - 30px) !important;
            }

            .owl-item:nth-child(1) {
                width: 300px !important;

                @include mini-mobile {
                    width: 250px !important;
                }
            }
        }

        .owl-nav {
            position: absolute;
            display: flex;
            justify-content: space-between;
            top: 47%;
            left: 0;
            right: 0;
            height: 25px;
            margin-top: 0;
            transform: translateY(-50%);
            background: none;
            pointer-events: none;

            &.disabled {
                display: none;
            }

            &:hover {
                background: none;
            }

            %base-nav {
                width: 25px;
                height: 25px;
                padding: 0;
                background-color: unset !important;
                background-position: center center;
                background-repeat: no-repeat;
                background-size: 100% 100%;
                pointer-events: all;
            }

            [class*='owl-'] {
                @extend %base-nav;

                &:hover {
                    @extend %base-nav;
                }
            }

            .owl-prev {
                @extend %base-nav;
                background-image: url('../../../../assets/icon/ic_prev.svg');

                &:hover {
                    @extend %base-nav;
                    background-image: url('../../../../assets/icon/ic_prev.svg');
                }

                &.disabled {
                    opacity: 0;
                }
            }

            .owl-next {
                @extend %base-nav;
                background-image: url('../../../../assets/icon/ic_next.svg');

                &:hover {
                    @extend %base-nav;
                    background-image: url('../../../../assets/icon/ic_next.svg');
                }

                &.disabled {
                    opacity: 0;
                }
            }
        }
    }
}
</style>
